import React,{useState,useEffect} from "react";
import Odometer from 'react-odometerjs';
import 'odometer/themes/odometer-theme-default.css';


export default function FunFacts() {

    const [customerSatisfaction, setCustomerSatisfaction] = useState(0);
    const [successfulDeliveries, setSuccessfulDeliveries] = useState(0);
    const [happyCustomers, setHappyCustomers] = useState(0);

    useEffect(() => {
        const timeoutId = setTimeout(() => setCustomerSatisfaction(100), 2000);
        return () => clearTimeout(timeoutId);
    }, []);

    useEffect(() => {
        const timeoutId = setTimeout(() => setSuccessfulDeliveries(135000), 2000);
        return () => clearTimeout(timeoutId);
    }, []);

    useEffect(() => {
        const timeoutId = setTimeout(() => setHappyCustomers(100000), 2000);
        return () => clearTimeout(timeoutId);
    }, []);

    return(
        <>
            <div className="col-md-4 mb-5 mb-md-5 px-4">
                <div className="wptb-counter1 style1 pr-60 position-relative z-index-3 wow skewIn">
                    <div className="wptb-item--inner">
                        <div className="wptb-item--holder d-flex align-items-center">
                            <div className="wptb-item--value" style={{fontSize:"30px"}}>
                                <Odometer value={customerSatisfaction}/>
                                <span className="suffix">%</span></div>
                            <div className="wptb-item--text">Customer Satisfaction</div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-4 mb-5 mb-md-5 px-4">
                <div className="wptb-counter1 style1 pd-right-60 position-relative z-index-3 wow skewIn">
                    <div className="wptb-item--inner">
                        <div className="wptb-item--holder d-flex align-items-center">
                            <div className="wptb-item--value flex-shrink-0" style={{fontSize:"30px"}}>
                                <Odometer value={successfulDeliveries}/>
                                <span className="suffix">+</span></div>
                            <div className="wptb-item--text" style={{fontSize:"15px",lineHeight:"20px"}}>Successful Deliveries</div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-4 mb-5 mb-md-5 px-4">
                <div className="wptb-counter1 style1 pd-right-60 position-relative z-index-3 wow skewIn">
                    <div className="wptb-item--inner">
                        <div className="wptb-item--holder d-flex align-items-center">
                            <div className="wptb-item--value flex-shrink-0" style={{fontSize:"30px"}}>
                                <Odometer value={happyCustomers}/>
                                <span className="suffix">+</span></div>
                            <div className="wptb-item--text">Happy Customers</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}